// NOTE: The string values assigned to these enum members (for example
// 'AdhocReq', 'Request', 'RemoteRq', 'RemoteIc') are part of the
// historical runtime contract with Relay and must remain unchanged.
// We expose descriptive enum member names for readability in the
// codebase, but the mapped string values are relied upon by API
// payloads — do not modify the string literals without coordinating
// a backend migration.

export enum TeamingType {
  // In-person ad hoc (preferred) teaming
  InCenterPreferredRequest = 'AdhocReq',
  // In-person any/standard request
  InCenterAnyRequest = 'Request',
  // Remote any request
  RemoteAnyRequest = 'RemoteRq',
  // Remote in-center request (remote but originated from in-center)
  RemoteInCenterRequest = 'RemoteIc',
}
